import langTranslate from 'locale'
import { API_STATES } from 'constants/stateMaps'

export const DEPARTURE_TIME_MAPPING = {
    '0000': {
        label: langTranslate('Early morning'),
        subLabel: langTranslate('Midnight - 8 am'),
        value: '0000',
        time: {
            start: 0,
            end: 800
        }
    },
    '0800': {
        label: langTranslate('Morning'),
        subLabel: langTranslate('8 am - Noon'),
        value: '0800',
        time: {
            start: 800,
            end: 1200
        }
    },
    '1200': {
        // label: langTranslate('Mid-day'),
        label: langTranslate('Afternoon'),
        subLabel: langTranslate('Noon - 4 pm'),
        value: '1200',
        time: {
            start: 1200,
            end: 1600
        }
    },
    '1600': {
        label: langTranslate('Evening'),
        subLabel: langTranslate('4 pm - 8 pm'),
        value: '1600',
        time: {
            start: 1600,
            end: 2000
        }
    },
    '2000': {
        label: langTranslate('Night'),
        subLabel: langTranslate('8 pm - Midnight'),
        value: '2000',
        time: {
            start: 2000,
            end: 2400
        }
    }
}

export const CFW_STATUS_FLAGS = ['TRIAL', 'TRIAL_NCB', 'VERIFIED', 'UNVERIFIED']

export const DATE_TAB_MATRICES = {
    fullScreen: {
        totalDays: 6,
        nextDays: 3,
        prevDays: 3
    },
    splitScreen: {
        totalDays: 2,
        nextDays: 1,
        prevDays: 1
    }
}

export const LSTORAGE_FILTER_DATA_KEY = 'FILTER_DATA'
export const LSTORAGE_COUNT_TO_SAVE = 5

export const API_STATES_FOUR = {
    ...API_STATES,
    INIT: 'INIT'
}

export const GSTIN_REGEX = /((0[1-9])|([1-2][0-9])|(3[0-6]))\s?\-?\s?[A-Za-z]{5}\d{4}[A-Za-z]\s?\-?\s?\d[A-Za-z][A-Za-z0-9]/i

export const PRICEVARIANTS = {
    INCREASED: 'INCREASED',
    DECREASED: 'DECREASED',
    NOT_AVAILABLE: 'NOT_AVAILABLE',
    NEAR_BY_AIRPORT: 'NEAR_BY_AIRPORT'
}

export const flightErrorStatus = {
    PRICE_CHANGED_SEATSELL1: 'PRICE_CHANGED_SEATSELL1',
    PRICE_CHANGED: 'PRICE_CHANGED',
    FLIGHT_NOT_AVAILABLE: 'FLIGHT_NOT_AVAILABLE',
    AIRPORT_CHANGE: 'AIRPORT_CHANGE',
    HOLD: 'HOLD'
}
